var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const CUSTOMERSAPP_GET_AUTH = "api/v2/washdayapp/auth";
const COMPANY_WEBSITE_AUTH = "api/v2/company-websites/auth";
const REGULAR_USER_AUTH = "api/auth";
export const revokeSession = function (sid, confirmation) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.post(`${REGULAR_USER_AUTH}/sessions/${encodeURIComponent(sid)}/revoke`, { password: confirmation.password }, { headers: { Authorization: `Bearer ${this.apiToken}` } });
        }
        catch (error) {
            throw error;
        }
    });
};
export const revokeOtherSessions = function (confirmation) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return yield this.axiosInstance.post(`${REGULAR_USER_AUTH}/sessions/revoke-others`, { password: confirmation.password }, { headers: { Authorization: `Bearer ${this.apiToken}` } });
        }
        catch (error) {
            throw error;
        }
    });
};
export const customerLoginToken = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {};
        return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/tokenLogin`, params, config);
    });
};
export const customerWebsiteSocialLoginExchange = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {};
        return yield this.axiosInstance.post(`${COMPANY_WEBSITE_AUTH}/social/exchange`, params, config);
    });
};
export const appleLogin = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/apple`, params, config);
        }
        catch (error) {
            console.error('Error fetching appleLogin:', error);
            throw error;
        }
    });
};
export const facebookLogin = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/facebook`, params, config);
        }
        catch (error) {
            console.error('Error fetching facebookLogin:', error);
            throw error;
        }
    });
};
export const customerRegularLogin = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {};
        return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/login`, params, config);
    });
};
export const customerSignUp = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = {};
        return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/signUp`, params, config);
    });
};
export const googleLogin = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/google`, params, config);
        }
        catch (error) {
            console.error('Error fetching googleLogin:', error);
            throw error;
        }
    });
};
export const regularUserLogin = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${REGULAR_USER_AUTH}/login`, params, config);
        }
        catch (error) {
            console.error('Error fetching regularUserLogin:', error);
            throw error;
        }
    });
};
export const companySignUp = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${REGULAR_USER_AUTH}/register`, params, config);
        }
        catch (error) {
            console.error('Error fetching companySignUp:', error);
            throw error;
        }
    });
};
export const regularUserTokenLogin = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = { timeout: 10000 };
            return yield this.axiosInstance.post(`${REGULAR_USER_AUTH}/tokenLogin`, params, config);
        }
        catch (error) {
            console.error('Error fetching regularUserTokenLogin:', error);
            throw error;
        }
    });
};
export const forgotPassword = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${REGULAR_USER_AUTH}/forget-password`, params, config);
        }
        catch (error) {
            console.error('Error fetching forgotPassword:', error);
            throw error;
        }
    });
};
export const customersAppForgotPassword = function (companyId, params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/${companyId}/forget-password`, params, config);
        }
        catch (error) {
            console.error('Error fetching customersAppForgotPassword:', error);
            throw error;
        }
    });
};
export const customersAppChangePassword = function (params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {};
            return yield this.axiosInstance.post(`${CUSTOMERSAPP_GET_AUTH}/change-password`, params, config);
        }
        catch (error) {
            console.error('Error fetching customerSignUp:', error);
            throw error;
        }
    });
};
export const pinLogin = function (data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                timeout: 15000,
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.post(`${REGULAR_USER_AUTH}/pin-login`, data, config);
        }
        catch (error) {
            console.error('Error fetching pinLogin:', error);
            throw error;
        }
    });
};
